<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <!-- <router-link to="/folders" v-if="isLoggedIn">Folders</router-link> | -->
      <span v-if="isLoggedIn"><router-link to="/tester">PV Tester</router-link> |</span>  
      <span v-if="isLoggedIn"><router-link to="/calibration">Calibration</router-link> |</span>  
      <span v-if="isLoggedIn"><router-link to="/multimetr">Multimetr</router-link> |</span>  
      <router-link to="/about">About</router-link> |    
      <span v-if="isAdmin"><router-link to="/admin">Admin</router-link> |</span>  
      <router-link to="/login" v-if="!isLoggedIn">Login</router-link>
      <a href="#" v-if="isLoggedIn" @click="logout">Log out</a>
      
    </div>
    <div class="container">
      <router-view/>
    </div>    
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      //isLoggedIn: false      
    }
  },
  //  async created () {
  //     if(this.$store.state.accessToken){                  
  //       this.isLoggedIn = true;
  //     }      
  //},
  computed: {
    isLoggedIn() {
      return this.$store.state.accessToken;
    },
    isAdmin(){
      return this.$store.state.isAdmin;
    }
  },
  methods: {
    ...mapActions(['deleteAccessToken']),
    logout() {
      if(!confirm("Sure to log out?"))
        return;
      this.deleteAccessToken();
      this.$router.push({name:"Login"});
    }
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
